import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemLabelComponent } from '../../common/item-label/item-label.component';
import { PriceTypeIndicatorComponent } from '../../common/price-type-indicator/price-type-indicator.component';
import { TooltipWrapperComponent } from '../../common/tooltip-wrapper/tooltip-wrapper.component';
import { PriceType } from '../../models/economy-models';

interface ItemDataVm {
  name: string;
  image?: string;
  tierColor?: string;
  tier?: string;
  movedUp?: number;
  movedDown?: number;
  movementAmount?: number;
  movementIcon?: string;
  isNewMovementGroup?: boolean;
}

interface UniqueDataVm {
  baseType: string;
  image?: string;
  tierColor?: string;
  tierAbbr?: string;
  tier?: string;
  movedUp?: number;
  movedDown?: number;
  movementAmount?: number;
  movementIcon?: string;
  isNewMovementGroup?: boolean;
  allUniques: Array<{
    name: string;
    image?: string;
    type?: PriceType;
  }>;
  nonRestrictedUniques: Array<{
    name: string;
    price: number;
  }>;
  averageValue?: number;
  lowestValue?: number;
}

@Component({
  selector: 'app-moved-tier-section',
  standalone: true,
  imports: [CommonModule, ItemLabelComponent, PriceTypeIndicatorComponent, TooltipWrapperComponent],
  templateUrl: './moved-tier-section.component.html',
  styleUrls: ['./moved-tier-section.component.scss', '../../tier-list-tab/tier-tab-common.scss', '../moved-tier-common.scss']
})
export class MovedTierSectionComponent {
  @Input({ required: true }) sectionTitle!: string;
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) cssClass!: string;
  @Input({ required: true }) isHidden!: boolean;
  @Input({ required: true }) currencyItems!: ItemDataVm[];
  @Input({ required: true }) uniqueItems!: UniqueDataVm[];
  @Input({ required: true }) alwaysGroupByBaseType!: boolean;
  @Input({ required: true }) currency!: string;
  @Input() groupingMode: 'movement' | 'tier' = 'movement';
  @Input() tierColor?: string;
  @Input() movementAmount?: number;
}
